export enum LiveEventAppearance {
  NewEventTypes = 'New',
  RecurringEventTypes = 'Recurring',
  NonrecurringEventTypes = 'Nonrecurring',
}
